const commonStore = {
  state: {
    loggedInUser: {},
  },
  reducers: {
    SET_LOGGED_USER: (state, loggedInUser) => ({
      ...state,
      loggedInUser,
    }),
  },
};

export default commonStore;
